export default __webpack_public_path__ + "static/media/surveys.ed30599e.png";